<template>
  <el-dialog :title="$t('mainCategory.add')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="addMainCategoryInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('mainCategory.categoryName')" prop="categoryName">
        <el-input v-model="addMainCategoryInfo.categoryName" :placeholder="$t('mainCategory.inputCategoryName')" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.startTime')" prop="startTime">
        <el-date-picker v-model="addMainCategoryInfo.startTime" type="datetime"
          :placeholder="$t('mainCategory.selectStartTime')" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.endTime')" prop="endTime">
        <el-date-picker v-model="addMainCategoryInfo.endTime" type="datetime"
          :placeholder="$t('mainCategory.selectEndTime')" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.seq')" prop="seq">
        <el-input v-model.number="addMainCategoryInfo.seq" :placeholder="$t('mainCategory.inputSeq')" />
      </el-form-item>
      <el-form-item :label="$t('mainCategory.desc')" prop="categoryDesc">
        <el-input v-model="addMainCategoryInfo.categoryDesc" type="textarea"
          :placeholder="$t('mainCategory.inputDesc')" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveMainCategoryInfo">
        {{ $t('common.save') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { saveMainCategory } from '@/api/admin/mainCategory/mainCategoryApi'

export default {
  name: 'AddMainCategory',
  data() {
    return {
      dialogVisible: false,
      addMainCategoryInfo: {
          shopId: getShopId(),
        categoryName: '',
        startTime: '',
        categoryType: '2',
        endTime: '',
        seq: '',
        categoryDesc: ''
      },
      rules: {
        categoryName: [
          { required: true, message: this.$t('mainCategory.categoryNameRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('mainCategory.categoryNameTooLong'), trigger: 'blur' }
        ],
        startTime: [
          { required: true, message: this.$t('mainCategory.startTimeRequired'), trigger: 'change' }
        ],
        endTime: [
          { required: true, message: this.$t('mainCategory.endTimeRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('mainCategory.seqRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('mainCategory.seqMustNumber'), trigger: 'blur' }
        ],
        categoryDesc: [
          { required: true, message: this.$t('mainCategory.descRequired'), trigger: 'blur' },
          { max: 512, message: this.$t('mainCategory.descTooLong'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async saveMainCategoryInfo() {
      try {
        await this.$refs.form.validate()
        await saveMainCategory(this.addMainCategoryInfo)
        this.$message.success(this.$t('mainCategory.addSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>